﻿import * as ko from 'knockout'
import $ from 'jquery'

import template from './LoginView.html?raw'
import './LoginStyles.less'
import '@/Styles/Variables.less'

interface ILoginParams {
    config: LoginViewModel;
}

export class LoginViewModel {

    isModal: boolean;
    licensedTo: string;
    logo: string;
    efetuarLogin: Function;
    urlPost: string;
    antiForgeryToken: string;
    authenticationMode: string;
    forgot: string;

    constructor(params: ILoginParams, componentInfo?: any) {
        Object.assign(this, params.config);

        $('#showHidePassword').click(function (e) {

            const icon =
                $('.dx-icon', e.currentTarget)

            if (icon.hasClass('dx-icon-eyeopen')) {

                icon.removeClass('dx-icon-eyeopen')
                icon.addClass('dx-icon-eyeclose')

                $('#Password').prop(
                    'type',
                    'text'
                )
            }
            else {

                icon.addClass('dx-icon-eyeopen')
                icon.removeClass('dx-icon-eyeclose')

                $('#Password').prop(
                    'type',
                    'password'
                )
            }
        });

        if (!this.isModal) {

            $("button[type='submit']").click(function (e) {

                e.preventDefault()

                $(this).attr(
                    'disabled',
                    'disabled'
                )

                $('form').submit()
            })
        }
    }
}

//Register the component
ko.components.register('login', { viewModel: LoginViewModel, template });
